var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoint3Icon32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "point3icon3-2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92.604,
    height: 92.551,
    viewBox: "0 0 92.604 92.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_119",
    "data-name": "\\u9577\\u65B9\\u5F62 119",
    width: 92.604,
    height: 92.551,
    fill: "#5f7cae"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_85",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 85",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_115",
    "data-name": "\\u30D1\\u30B9 115",
    d: "M9.23,61.691v2.99H3.285v6.142l2.75.17v3.024l-2.826.167v6H92.6V83.31H90.635q-43.732,0-87.464,0C.114,83.309,0,83.191,0,80.159V0H3.094V6H9c.732,2.984.593,3.166-2.2,3.173-1.026,0-2.051.021-3.076.042a2.22,2.22,0,0,0-.474.158v5.871l2.823.212v2.831l-2.814.183v6H9.17v3.2H3.258V33.8l2.8.17v2.824l-2.843.3v5.995H9.151V46.2h-5.9v6.121l2.787.147v2.981l-2.784.184v6.062Z",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_116",
    "data-name": "\\u30D1\\u30B9 116",
    d: "M84.128,39.189c2.693-1.619,5.212-1.65,7.721.146a1.657,1.657,0,0,0,1.413-.122c3.093-1.752,6.177-3.523,9.192-5.4A2.5,2.5,0,0,0,103.4,32a6.247,6.247,0,0,1,5.813-6.434,6.172,6.172,0,0,1,6.454,5.371,5.766,5.766,0,0,1-2.52,5.822,5.894,5.894,0,0,1-6.478.424,19.522,19.522,0,0,1-1.769-1.151c-3.369,1.973-6.809,3.951-10.193,6.018a1.964,1.964,0,0,0-.6,1.468c-.019,4.231-2.754,6.95-6.741,6.72a6.151,6.151,0,0,1-5.411-7.79A1.768,1.768,0,0,0,81.364,41q-5.206-4.208-10.526-8.272a2.553,2.553,0,0,0-1.694-.126c-1,.151-2.016.731-2.949.6-1.529-.22-2.225.369-2.978,1.588Q56.75,45.241,50.1,55.584a2.193,2.193,0,0,0-.078,2.713,5.94,5.94,0,0,1-1.408,7.527,6.243,6.243,0,0,1-7.542.345,6.167,6.167,0,0,1-2.122-7.4,5.96,5.96,0,0,1,6.546-3.7,1.518,1.518,0,0,0,1.86-.879c4.551-7.248,9.142-14.47,13.651-21.744a2.428,2.428,0,0,0,.011-2.032c-1.429-2.751-1.221-5.426.754-7.53a6.167,6.167,0,0,1,7.3-1.275A6.35,6.35,0,0,1,72.3,28.643a1.984,1.984,0,0,0,.512,1.59c3.7,3,7.459,5.922,11.313,8.956M44.681,64.233a3.207,3.207,0,0,0,3.028-3.194,3.074,3.074,0,0,0-6.143.1,3.181,3.181,0,0,0,3.116,3.1m67.906-32.487a2.928,2.928,0,0,0-3.106-3,3.024,3.024,0,0,0-3.019,2.957,3.208,3.208,0,0,0,3.067,3.171,3.111,3.111,0,0,0,3.057-3.127M69.372,27.189a3.146,3.146,0,0,0-3.084-3.112,2.941,2.941,0,0,0-3.029,2.9,3.025,3.025,0,0,0,2.909,3.236,3.209,3.209,0,0,0,3.2-3.025M87.849,41.1a3.062,3.062,0,0,0-3,3.151,3.133,3.133,0,0,0,3.036,2.98,3.051,3.051,0,0,0,3.06-3.1A2.966,2.966,0,0,0,87.849,41.1",
    transform: "translate(-24.536 -13.351)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_117",
    "data-name": "\\u30D1\\u30B9 117",
    d: "M106.363,88.137c-4.255,5.324-8.562,10.683-12.807,16.09a1.968,1.968,0,0,0-.176,1.693,6.046,6.046,0,0,1-.889,6.914,5.824,5.824,0,0,1-6.25,1.842,6.088,6.088,0,0,1-4.525-5.121,2,2,0,0,0-1.161-1.245q-3.955-1.252-7.985-2.257a2,2,0,0,0-1.594.494,6.35,6.35,0,0,1-7.758,1.41,2.032,2.032,0,0,0-1.7.142c-3.418,2.476-6.76,5.054-10.161,7.553a1.81,1.81,0,0,0-.85,2.345,6.138,6.138,0,1,1-11.934,2.849,6,6,0,0,1,4.984-7.308,5.221,5.221,0,0,1,2.99.252c1.233.6,1.956.187,2.875-.522,3.294-2.54,6.631-5.026,9.982-7.492a1.754,1.754,0,0,0,.834-2.094,6.118,6.118,0,1,1,12.009-2.349,1.94,1.94,0,0,0,1.725,1.852c2.382.635,4.751,1.325,7.111,2.038a1.88,1.88,0,0,0,2.34-.6,5.538,5.538,0,0,1,5.727-1.817,1.813,1.813,0,0,0,2.131-.722q5.978-7.614,12.073-15.135a2.088,2.088,0,0,0,.439-2.39,6.154,6.154,0,0,1,4.149-8.138,6.217,6.217,0,1,1,2.17,12.189,19.408,19.408,0,0,1-3.749-.473M47.683,119.628a3.076,3.076,0,0,0-6.146-.193,3.075,3.075,0,1,0,6.146.193m18.63-13.986a3.184,3.184,0,0,0,3.015-3.2,3.061,3.061,0,0,0-3.239-2.917,2.905,2.905,0,0,0-2.865,3.048,3.059,3.059,0,0,0,3.09,3.073m43.3-26.254a3.178,3.178,0,0,0-3.183,3.036,3.032,3.032,0,0,0,2.9,3.068,2.936,2.936,0,0,0,3.223-2.876,3.109,3.109,0,0,0-2.945-3.227M87.768,105.729a3.091,3.091,0,0,0-2.947,3.05,3.132,3.132,0,0,0,3.132,3.066,3.06,3.06,0,0,0-.185-6.116",
    transform: "translate(-24.506 -48.608)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_111",
    "data-name": "\\u9577\\u65B9\\u5F62 111",
    width: 2.92,
    height: 5.997,
    transform: "translate(37.168 86.509)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_112",
    "data-name": "\\u9577\\u65B9\\u5F62 112",
    width: 2.846,
    height: 6.005,
    transform: "translate(43.386 86.54)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_113",
    "data-name": "\\u9577\\u65B9\\u5F62 113",
    width: 2.934,
    height: 5.997,
    transform: "translate(58.823 86.554)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_114",
    "data-name": "\\u9577\\u65B9\\u5F62 114",
    width: 2.969,
    height: 5.91,
    transform: "translate(64.955 86.57)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_115",
    "data-name": "\\u9577\\u65B9\\u5F62 115",
    width: 2.8,
    height: 5.922,
    transform: "translate(15.64 86.564)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_116",
    "data-name": "\\u9577\\u65B9\\u5F62 116",
    width: 2.88,
    height: 5.872,
    transform: "translate(21.774 86.594)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_117",
    "data-name": "\\u9577\\u65B9\\u5F62 117",
    width: 2.834,
    height: 5.962,
    transform: "translate(80.523 86.544)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_118",
    "data-name": "\\u9577\\u65B9\\u5F62 118",
    width: 2.917,
    height: 5.893,
    transform: "translate(86.672 86.58)",
    fill: "#5f7cae"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint3Icon32);
export default __webpack_public_path__ + "static/media/point3icon3-2.e093e596806d93cb9191be98d1d64799.svg";
export { ForwardRef as ReactComponent };